/**
 * @generated SignedSource<<e2a399644e1b8d34a017a465a1af7e79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VideoFileStatus = "ERROR" | "PROCESSING" | "READY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type muxVideoExtensionFragment$data = {
  readonly id: string;
  readonly playback: {
    readonly playback: string;
    readonly tokens: {
      readonly playback: string | null | undefined;
      readonly storyboard: string | null | undefined;
      readonly thumbnail: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly status: VideoFileStatus;
  readonly thumbnail: {
    readonly signedUrl: string;
  } | null | undefined;
  readonly " $fragmentType": "muxVideoExtensionFragment";
};
export type muxVideoExtensionFragment$key = {
  readonly " $data"?: muxVideoExtensionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"muxVideoExtensionFragment">;
};

import muxVideoQuery_graphql from './muxVideoQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "playback",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": muxVideoQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "muxVideoExtensionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageFile",
      "kind": "LinkedField",
      "name": "thumbnail",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signedUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "VideoPlayback",
      "kind": "LinkedField",
      "name": "playback",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "VideoFileTokens",
          "kind": "LinkedField",
          "name": "tokens",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thumbnail",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "storyboard",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "VideoFile",
  "abstractKey": null
};
})();

(node as any).hash = "d3c6104eba208541d0aa6711dfa6065a";

export default node;
